import { render, staticRenderFns } from "./webFooter.vue?vue&type=template&id=adcb9b66&scoped=true&"
import script from "./webFooter.vue?vue&type=script&lang=js&"
export * from "./webFooter.vue?vue&type=script&lang=js&"
import style0 from "./webFooter.vue?vue&type=style&index=0&id=adcb9b66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcb9b66",
  null
  
)

export default component.exports